import React, { Component } from 'react'
import { BackTop, Col, Row } from 'antd';

export default class BodyContent extends Component {
 
  render() {

    return (
      <div className="wrapper">
        <BackTop />
        <div className="subwrapper bg-1">
          <span className="anchor" id="zone-icons" />
          <div className="container">
            <Row>
              <Col xs={24}>
                <div className="lf-title-card">
                  <h2>Zone Icons</h2>
                </div>
              </Col>
            </Row>
            <div className="lf-card">
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <h3>Home</h3>
                  <div className="icon"><i className="fal fa-handshake-alt"></i><span>Welcome</span></div>
                  <div className="icon"><i className="fal fa-check-circle"></i><span>Attendance Options</span></div>
                  <div className="icon"><i className="fal fa-check-square"></i><span>Subject Learning Outcomes</span></div>
                  <div className="icon"><i className="fal fa-map-signs"></i><span>Getting Started</span></div>
                  <div className="icon"><i className="fal fa-map"></i><span>Learning Guide</span></div>
                  <div className="icon"><i className="fal fa-clipboard-list"></i><span>Essential Resources</span></div>
                  <div className="icon"><i className="fal fa-users"></i><span>Teaching Staff</span></div>
                  <div className="icon"><i className="fal fa-align-left"></i><span>Assessment Summary</span></div>
                  <div className="icon"><i className="fal fa-laptop"></i><span>Technical Skills and Recommended Software</span></div>

                  <h3>Communication Zone &gt; Discussion</h3>
                  <div className="icon"><i className="fal fa-comment-dots"></i><span>Discussion Board</span></div>
                  <div className="icon"><i className="fal fa-comment-alt-smile"></i><span>Online Netiquette</span></div>

                  <h3>Support Zone &gt; Student Services</h3>
                  <div className="icon"><i className="fal fa-cog"></i><span>Student Services</span></div>
                </Col>
                <Col xs={24} md={12}>
                  <h3>Learning Zone &gt; Learning Modules</h3>
                  <div className="icon"><i className="fal fa-bars"></i><span>Overview</span></div>
                  <div className="icon"><i className="fal fa-sitemap"></i><span>Module Learning Outcomes</span></div>
                  <div className="icon"><i className="fal fa-play-circle"></i><span>Concept Pods</span></div>
                  <div className="icon"><i className="fal fa-file-alt"></i><span>Lecture</span></div>
                  <div className="icon"><i className="fal fa-play-circle"></i><span>Videos</span></div>
                  <div className="icon"><i className="fal fa-book"></i><span>Essential Readings &#47; Readings</span></div>
                  <div className="icon"><i className="fal fa-check-square"></i><span>Pre Tutorial &#47; Pre Class &#47; Pre Seminar &#47; Pre Workshop &#47; Pre Practical &#47; Pre session</span></div>
                  <div className="icon"><i className="fal fa-pencil"></i><span>Tutorial Plan &#47; Class Activities &#47; Tutorial &#47; Class &#47; Seminar &#47; Workshop &#47; Practical &#47; CPU &#47; Session</span></div>
                  <div className="icon"><i className="fal fa-check-circle"></i><span>Post Tutorial &#47; Post Class &#47; Post Seminar &#47; Post Workshop &#47; Post Practical &#47; Post session</span></div>
                  <div className="icon"><i className="fal fa-bookmark"></i><span>Supplementary Resources</span></div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        
        <div className="subwrapper bg-2">
          <span className="anchor" id="content-area-icons" />
          <div className="container">
            <Row>
              <Col xs={24}>         
                <div className="lf-title-card">
                  <h2>Content Area Icons</h2>
                </div>
              </Col>
            </Row>
            <div className="lf-card">
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <div className="icon highlight"><i className="fal fa-file-alt highlight"></i><span>Default icon if none specified</span></div>
                  <div className="icon"><i className="fal fa-folder"></i><span>Content Area</span></div>
                  <div className="icon"><i className="fal fa-boxes"></i><span>Learning Module</span></div>
                  <div className="icon"><i className="fal fa-boxes"></i><span>Lesson Plan</span></div>
                  <div className="icon"><i className="fal fa-link"></i><span>Course Link</span></div>
                  <div className="icon"><i className="fal fa-laptop"></i><span>Content Package &#40;SCORM&#41;</span></div>
                  <div className="icon"><i className="fal fa-file-alt"></i><span>Item</span></div>
                  <div className="icon"><i className="fal fa-file"></i><span>File</span></div>
                  <div className="icon"><i className="fal fa-external-link"></i><span>Web Link</span></div>
                  <div className="icon"><i className="fal fa-volume-up"></i><span>Audio</span></div>
                  <div className="icon"><i className="fal fa-image"></i><span>Image</span></div>
                  <div className="icon"><i className="fal fa-play-circle"></i><span>Video</span></div>
                  <div className="icon"><i className="fab fa-youtube"></i><span>Mashup YouTube</span></div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="icon"><i className="fab fa-flickr"></i><span>Mashup Flickr</span></div>
                  <div className="icon"><i className="fab fa-slideshare"></i><span>Mashup Slideshare</span></div>
                  <div className="icon"><i className="fal fa-upload"></i><span>Assignment</span></div>
                  <div className="icon"><i className="fal fa-upload"></i><span>Turnitin Assignment</span></div>
                  <div className="icon"><i className="fal fa-check-square"></i><span>Test</span></div>
                  <div className="icon"><i className="fal fa-clipboard-list"></i><span>Survey</span></div>
                  <div className="icon"><i className="fal fa-users"></i><span>Self and Peer Assessment</span></div>
                  <div className="icon"><i className="fal fa-check-square"></i><span>Mobile Compatible Test</span></div>
                  <div className="icon"><i className="fal fa-comment-dots"></i><span>Discussion</span></div>
                  <div className="icon"><i className="fal fa-rss"></i><span>Blog</span></div>
                  <div className="icon"><i className="fal fa-pencil"></i><span>Journal</span></div>
                  <div className="icon"><i className="fab fa-wikipedia-w"></i><span>Wiki</span></div>
                  <div className="icon"><i className="fal fa-users"></i><span>Group</span></div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="subwrapper bg-3">
          <span className="anchor" id="other-icons" />
          <div className="container">
            <Row id="other-icons">
              <Col xs={24}>
                <div className="lf-title-card">
                  <h2>Other Icons</h2>
                </div>
              </Col>
            </Row>
            <div className="lf-card">
              <Row>
                <Col xs={24}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <h3>Unique Items</h3>
                      <p>These additional icons will appear beside items that fall outside the LMS template.</p>
                    </Col>
                    <Col xs={24} md={12}>
                      <div className="icon"><i className="fal fa-trophy"></i><span>Achievement</span></div>
                      <div className="icon"><i className="fal fa-code-branch"></i><span>Activity &#47; Activities</span></div>	
                      <div className="icon"><i className="fal fa-search"></i><span>Case Study &#47; Research</span></div>
                      <div className="icon"><i className="fal fa-copyright"></i><span>Copyright Notices</span></div>
                      <div className="icon"><i className="fab fa-facebook-f"></i><span>Facebook</span></div>
                      <div className="icon"><i className="fal fa-lightbulb"></i><span>L2L (Learn 2 Learn)</span></div>	
                      <div className="icon"><i className="fab fa-twitter"></i><span>Twitter</span></div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="subwrapper bg-4">
          <span className="anchor" id="ui-icons" />
          <div className="container">
            <Row id="ui-icons">
              <Col xs={24}>
                <div className="lf-title-card">
                  <h2>UI Icons</h2>
                </div>
              </Col>
            </Row>
            <div className="lf-card">
              <Row>
                <Col xs={24}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <h3>Show/Hide Buttons</h3>
                      <p>These UI icons appear beside all items to indicate collapsible content.</p>
                    </Col>
                    <Col xs={24} md={12}>
                      <div className="icon"><i className="fal fa-plus-circle"></i><span>Show</span></div>
                      <div className="icon"><i className="fal fa-minus-circle"></i><span>Hide</span></div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>

      </div>
    )
  }
}